import { render, staticRenderFns } from "./EVDDisplayText.vue?vue&type=template&id=2e7ba222&scoped=true&"
import script from "./EVDDisplayText.vue?vue&type=script&lang=js&"
export * from "./EVDDisplayText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ba222",
  null
  
)

export default component.exports